// The loading screen's lines to say aloud (update-lines.data.ts): one Peterson line with its
// Finnish, the next every LINE_MS. A plain swap, no motion (DESIGN.md Motion).
import { useEffect, useState } from 'react';
import { Hv } from '../components/Hv';
import { useT } from '../i18n';
import { LINE_MS, UPDATE_LINES } from './update-lines.data';

export function UpdateLines() {
  const t = useT();
  const [i, setI] = useState(() => Math.floor(Math.random() * UPDATE_LINES.length));
  useEffect(() => {
    const id = window.setInterval(() => setI((n) => (n + 1) % UPDATE_LINES.length), LINE_MS);
    return () => window.clearInterval(id);
  }, []);
  const line = UPDATE_LINES[i]!;
  return (
    <figure className="update-lines" data-update-line={line.id}>
      <figcaption className="update-lines-label">{t.updateLines.label}</figcaption>
      <Hv as="p" className="update-lines-hv" link={false}>
        {line.hv}
      </Hv>
      <p className="update-lines-fi">{line.fi}</p>
    </figure>
  );
}
